<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>

<!------------------------------

    Table Wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.headlines.markers' | translate}}"
  [isInModalContext]="isInModalContext"
  [itemsData]="markers"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'markers'">

  <!------------------------------

    Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>

  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>
    <tr>
      <th>{{ 'lang.globals.marker' | translate }}</th>
      <th>{{ 'lang.globals.resolution' | translate }}</th>
      <th>{{ 'lang.globals.channel' | translate }}</th>
      <th class="tr bw sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>

  <!------------------------------

      Table Body

------------------------------->

  <ng-template #tbody let-marker>
    <tr>
      <td>{{ marker.name }}</td>
      <td>
        {{ marker?.resolution?.id }}
      </td>
      <td>
        <sb-comp-image-name-wrapper [image]="marker.channel?.logo?.url">
          <span firstLine [innerHTML]="marker.channel?.name | truncate:30"></span>
          <span secondLine [innerHTML]="marker.channel?.description | truncate: 45"></span>
        </sb-comp-image-name-wrapper>
      </td>
      <td class="tr bw sticky-col last-col">
        <sb-split-button
          [splitButtonItems]="marker.sbButtons ?? []"
          (selectedAction)="resolveSplitButtonAction(marker, $event)"
        ></sb-split-button>
      </td>
    </tr>
  </ng-template>

</sb-table-wrapper-new>
